export default {
  'dashboard': {
    'objetives': {
      'digitalization': {
        'title': 'Resultados económicos'
      },
      'economic': {
        'title': 'Servicios digitales'
      },
      'efficiency': {
        'title': 'Seguridad y Medio ambiente'
      },
      'people': {
        'title': 'Recursos Humanos'
      },
      'security': {
        'title': 'Producción'
      }
    }
  },
  'dashboardNav': {
    'steeringCommittee': 'Comité de Dirección',
    'departments': 'Departamentos',
    'sales': 'Comercial',
    'operations': 'Operaciones',
    'manufacturing': 'Producción',
    'logistics': 'Logística y Almacén',
    'financial': 'Financiero',
    'purchases': 'Compras',
    'safetyQualityAndEnvironment': 'Seguridad, Calidad y Medioambiente',
    'r_d': 'I+D',
    'humanResources': 'Recursos Humanos',
    'processes': 'Procesos',
    'projectManagement': 'Gestión de Proyectos',
    'productDevelopment': 'Desarrollo de Producto'
  },
  'explore': {
    'title': 'Selecciona tipo de exploración'
  },
  'explorer': {
    'from': 'Lecturas desde',
    'sampledVariables': 'Variables resumidas:',
    'breadcrumbParent': 'Explorador: Evolución temporal',
    'breadcrumbParentOldExplorer': 'Explorador: Correlación', // TODO refactor to a generic breadcrumb with the new explorer
    'breadcrumbMultipleCorrelation': 'Explorer: Correlación benchmark',
    'parameterSelection': 'Selección de parámetros',
    'datesSelection': 'Selección de rango temporal',
    'categories': 'Categorías',
    'none': 'Ninguna',
    'checkedIntensity': 'Intensidad',
    'checkedIndividualCategory': 'Categoría individual',
    'checkedGlobalCategory': 'Categoría global',
    'addVariables': 'Añadir variables',
    'selectionVariables': 'Selección de variables',
    'selectionMultipleVariables': 'Selección múltiple de variables',
    'reset': 'Restablecer valores',
    'rangeErrorMin': 'Valor mínimo menor que el máximo',
    'rangeErrorMax': 'Valor máximo mayor que el mínimo',
    'max': 'Valor máximo',
    'min': 'Valor mínimo',
    'optionsDropdown': 'Opciones de visualización',
    'axisX': 'Eje X',
    'axisY': 'Eje Y',
    'multipleCorrelation': 'Correlación benchmark',
    'intensity': 'Intensidad',
    'correlationSelectTitle': 'Selecciona la correlación a exportar',
    'correlationOptions': {
      'fixedAxes': 'Ajustar ejes',
      'toEvolution': 'Cambiar a evolución',
      'divergent': 'Cambiar a colores divergentes',
      'sequential': 'Cambiar a colores secuenciales',
      'exchangeAxes': 'Intercambiar ejes'
    },
    'evolutionOptions': {
      'fixedAxes': 'Ajustar eje y',
      'singleAxis': 'Eje único  ',
      'toCorrelation': 'Cambiar a correlación',
      'gridVisibleChecked': 'Rejilla',
      'showPoints': 'Mostrar puntos'
    },
    'defaultRangeDate': {
      'today': 'Hoy',
      'yesterday': 'Ayer',
      'last7Days': 'Últimos 7 días',
      'last30Days': 'Últimos 30 días',
      'thisMonth': 'Este mes',
      'lastMonth': 'Último mes',
      'custom': 'Personalizado'
    },
    'menu': {
      'clearSelection': 'Borrar selección',
      'aggregateFunctionDescription': 'Permite seleccionar la función de agregación media, suma, máximo y mínimo por cada variable seleccionada.',
      'aggregateFunctionTitle': 'Función de agregación',
      'evolution': {
        'description': 'Gráfico de líneas',
        'info': 'Permite comparar dos variables y enfrentarlas contra la misma línea temporal.',
        'label': 'Evolución temporal',
        'uniqueAxis': 'Eje único'
      },
      'explore': 'Explorar',
      'intensity': 'Permite añadir más información a los puntos de las gráficas otorgándoles una intensidad basada en una tercera variable. ',
      'loadVariablesDescription': 'Permite buscar, seleccionar y cargar variables disponibles en la gráfica para compararlas entre ellas.',
      'loadVariablesLabel': 'Añadir variables',
      'multiple': {
        'chart1': 'Gráfico 1',
        'chart2': 'Gráfico 2',
        'chart3': 'Gráfico 3',
        'chart4': 'Gráfico 4',
        'description': 'Scatter plot',
        'info': 'Permite buscar hasta por 9 variables y mostrar la información en 4 gráficos , además de la novena variable en forma de intensidad en cada una de las 4 gráficas, mostrando así la correlación entre tres variables en cada una de las cuatro gráficas.',
        'intensidad': 'Intensidad',
        'label': 'Correlación múltiple',
        'xAxis': 'Eje X',
        'yAxis': 'Eje y'
      },
      'relations': {
        'description': 'Scatter plot',
        'info': 'Permite enfrentar dos variables en un scatter plot para poder encontrar correlaciones entre dos variables cuantitativas. Permite también añadir más información a los puntos otorgándoles una intensidad basada en una tercera variable.',
        'intensity': 'Intensidad',
        'label': 'Correlación simple'
      },
      'tagVariable': 'tag variable…',
      'title': '¿Qué quieres mostrar?'
    },
    'selectorModal': {
      'header': 'Añadir variable',
      'function': 'Función de agregación',
      'add': 'Añadir',
      'addVariablePlaceholder': 'Seleccionar variables',
      'modalMandatoryFieldsNotification': 'Selecciona variables'
    },
    'queryModal': {
      'title': 'Guardar consulta',
      'queryName': 'Nombre de la consulta',
      'checkboxLabel': 'Incluir rango de fechas',
      'tooltipTitle': 'Info',
      'tooltipDescription': 'Si esta opción esta seleccionada la fecha de inicio y la fecha de fin están incluidos en la consulta',
      'queryNameError': 'Debes introducir un nombre de consulta'
    },
    'showMenuButtonLabel': 'Menú explorador',
    'title': 'Explorador',
    'to': 'hasta',
    'urlCopy': 'La URL ha sido copiada',
    'urlSave': 'El nombre de la consulta',
    'copyUrlError': 'No has realizado ninguna consulta. Pulsa en \'EXPLORAR\'',
    'noVariableSelected': 'Selecciona al menos una variable antes de explorar los datos',
    'intensityVariableRequired': 'Seleccione la variable intensidad para poder mostrar la gráfica con colores',
    'selectUnlessFirstTwoVariables': 'Seleccione al menos las dos primeras variables antes de explorar los datos',
    'selectUnlessTwoVariables': 'Seleccione al menos dos variables de un gráfico antes de explorar los datos',
    'selectMultiplePairs': 'Selecciona las parejas de variables (4 max)'
  },
  'aggregateVariable': {
    'aggregateVariable': 'Variables agregada',
    'title': 'Variables agregadas',
    'addAggregateVariable': 'Crear variable agregada',
    'editAggregateVariable': 'Editar variable agregada',
    'creationDate': 'Fecha de creación',
    'createdBy': 'Propietario',
    'algorithm': 'Fórmula',
    'variable': 'Variable',
    'constant': 'Constante',
    'operator': 'Operador',
    'name': 'Nombre',
    'unit': 'Unidad',
    'successCreation': 'Variable {name} creada con éxito',
    'errorCreation': 'Ocurrió un error al crear la variable {name}',
    'successUpdate': 'Variable {name} actualizada con éxito',
    'errorUpdate': 'Ocurrió un error al actualizar la variable {name}',
    'successDelete': 'Variable {name} eliminada con éxito',
    'errorDelete': 'Ocurrió un error al eliminar la variable {name}',
    'deleteModalTitle': 'Eliminar variable agregada',
    'deleteModalMessage': '¿Estás seguro de que deseas eliminar la variable agregada?',
    'deleteDependenciesMessage': 'No se pudo eliminar la variable porque tiene las siguientes dependencias:',
    'variableDependencies': 'Variables',
    'ruleDependencies': 'Reglas',
    'constantVariables': 'Operaciones entre variables y constantes',
    'gradualVariables': 'Incremento de variable en el tiempo',
    'gradualIncrement': 'Incremento de "{name}" en {timeGap}',
    'metricalVariables': 'Métricas de planta',
    'calculateHistoricalData': 'Calcular el histórico'
  },
  'aggregateGradualVariable': {
    'selectVariable': 'Selecciona variable',
    'timeGap': 'Rango temporal para el cálculo del incremento',
    'oneMinute': '1 Minuto',
    'oneHour': '1 Hora',
    'oneDay': '1 Día',
    'oneMonth': '1 Mes',
    'aggregateVariable': 'Variable agregada',
    'timeGapTitle': 'Rango temporal',
    'editAggregateGradualVariable': 'Editar variable agregada incremental',
    'addAggregateGradualVariable': 'Crear variable agregada incremental',
    'calculateHistoricalData': 'Calcular el histórico'
  },
  'aggregateMetricalVariable': {
    'addAggregateMetricalVariable': 'Crear métrica de planta',
    'editAggregateMetricalVariable': 'Editar métrica de planta',
    'metrical': 'Métrica',
    'metrics': {
      'mean': 'Media aritmética',
      'median': 'Mediana',
      'maximum': 'Máximo',
      'minimum': 'Mínimo',
      'standardDeviation': 'Desviación estándar',
      'q1': 'Q1',
      'q3': 'Q3'
    },
    'calculateHistoricalData': 'Calcular el histórico'
  },
  'rawVariable': {
    'title': 'Variables nativas',
    'editRawVariable': 'Editar variable nativa',
    'reference': 'Referencia'
  },
  'variables': {
    'variableSelector': 'Selector de variables',
    'taxonomy': 'Taxonomía de variables',
    'tags': 'Etiquetas',
    'variables': 'Variables',
    'add': 'Añadir',
    'addTag': 'Añadir etiqueta',
    'addChildTag': 'Añadir etiqueta bajo',
    'reference': 'Referencia',
    'name': 'Nombre',
    'unit': 'Unidad',
    'deleteModal': 'La etiqueta es usada por alguna variable. ¿Quieres borrarla de todas formas?',
    'updateModal': 'Alguna etiqueta que es usada por al menos una variable ahora es una categoría de etiquetas. Dichas etiquetas se eliminarán de las variables que las contenían. ¿Quieres actualizar de todas formas?',
    'editionTitle': 'Asignación grupal de etiquetas',
    'selection': 'Seleccionar / Deseleccionar todas las variables',
    'filter': 'Filtrar por etiquetas',
    'repeatedTags': 'Etiquetas repetidas: {tags}',
    'multipleTagsExample': 'etiqueta1, etiqueta2, etiqueta3',
    'andXMore': 'y {count} más'
  },
  'filter': {
    'filterModeTitleMobile': 'Período',
    'cancel': 'cancelar',
    'hour': 'Selecciona Hora',
    'minute': 'Selecciona Minuto',
    'monthly': 'Mensual',
    'second': 'Selecciona Segundo',
    'submit': 'confirmar',
    'today': 'Hoy es',
    'yearly': 'Anual'
  },
  'login': {
    'contact': 'Si tienes problemas con tu nombre de usuario o contraseña contacta con <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a>',
    'resetPassword': 'Con correo verificado puedes resetear la contraseña <a href="/#/password/reset">aquí</a>',
    'enter': 'Iniciar sesión',
    'alreadyHaveAnAccount': '¿Ya dispones de una cuenta?',
    'help': '¿No logras identificarte?',
    'password': 'Contraseña',
    'subtitle': 'Por favor, identifícate con tu usuario y contraseña para poder acceder.',
    'title': 'Bienvenido a X-Dwall',
    'user': 'Usuario',
    'userErrorMessage': 'Usuario no encontrado',
    'userLabel': 'Usuario',
    'userPlaceholder': 'Escribe aquí tu nombre de usuario',
    'passwordPlaceholder': 'Escribe aquí tu contraseña',
    'passwordErrorMessage': 'Contraseña incorrecta'
  },
  'resetPassword': {
    'userLabel': 'Usuario',
    'userPlaceholder': 'Escribe aquí tu nombre de usuario',
    'user': 'Usuario',
    'subtitle': 'Por favor, identifícate con tu usuario y le enviaremos un correo.',
    'title': 'Reseteo contraseña',
    'send': 'Enviar'
  },
  'emailVerification': {
    'noParam': 'No hay token',
    'error': '¡Uy! Algo ha salido mal',
    'success': 'Ok',
    'title': 'Verificando email',
    'sendEmail': 'Enviado correo para proceso de verificación',
    'errorSendEmail': 'Error proceso de verificación',
    'duplicatedEmail': 'Este email ya ha sido registrado previamente'
  },
  'signin': {
    'title': 'Regístrate',
    'btn': 'Crear cuenta',
    'noAccountCreate': 'Crear cuenta',
    'email': 'Email',
    'notValidEmail': 'Email no válido',
    'duplicatedEmail': 'EL email introducido ya ha sido registrado previamente',
    'success': 'Bienvenido :)',
    'error': 'Oops',
    'termsAndConditions': 'Términos y Condiciones de Uso',
    'advice': 'Al hacer clic en Registrarte, aceptas los <a href="/#/legal" target="_blank">Términos y Condiciones de Uso</a>.'
  },
  'management': {
    'filterModeTitle': 'Información',
    'goal': 'Objetivo',
    'goals': 'Objetivos',
    'managementComite': 'Comité de dirección',
    'managementPanel': 'Cuadros de mando',
    'evolution': 'Evolución',
    'objetives': {
      'digitalization': {
        'description': 'Iniciar la diversificación de actividad.<br>Lanzar la estrategia de digitalización.',
        'title': 'Digitalización y Nuevos Negocios'
      },
      'economic': {
        'description': 'Alcanzar el margen de refino actual establecido.<br>Cumplir con el plan de costes anual establecido.',
        'title': 'Resultados económicos'
      },
      'efficiency': {
        'description': 'Mejorar la gestión energética. Consumos y normas.<br>Mejorar la disponibilidad y utilización de las unidades.',
        'title': 'Eficiencia'
      },
      'people': {
        'description': 'Mejorar la reputación de la compañía.<br>Incrementar el compromiso de las personas con el proyecto de Petronor.',
        'title': 'Personas y sostenibilidad'
      },
      'security': {
        'description': 'Mejorar la seguridad de las persionas y las instalaciones.<br>Minimizar los impactos derivados de nuestra actividad.',
        'title': 'Seguridad y Medio Ambiente'
      }
    },
    'secondaryMenuBtn': 'Cuadros de mando de gestión'
  },
  'market': {
    'filterTitleLeft': 'Medias de',
    'filterTitleRight': 'Diferencia respecto a',
    'filterModeTitle': 'Información',
    'evolution': 'Evolución',
    'objetivesTitle': 'Objetivos',
    'crude': 'Crudo',
    'product': 'Producto',
    'margin': 'Margin',
    'marketTitle': 'Mercado',
    'strategicLines': 'Líneas estratégicas',
    'strategy': {
      'first': {
        'objetives': {
          'first': 'Mejorar la seguridad de las personas y las instalaciones.',
          'fourth': 'Mejorar la reputación de la compañía.',
          'second': 'Minimizar los impactos derivados de nuestra actividad.',
          'third': 'Mejorar la gestión energética. Consumos y normas.'
        },
        'title': 'Minimizar los impactos derivados de nuestra actividad y ser motor del desarrollo de nuestro entorno.'
      },
      'fourth': {
        'objetives': {
          'first': 'Iniciar la diversificación de actividad.',
          'second': 'Lanzar la estrategia de digitalización.'
        },
        'title': 'Gestionar la innovación: innovación abierta y rentable.'
      },
      'second': {
        'objetives': {
          'first': 'Alcanzar el margen de refino actual establecido.',
          'fourth': 'Mejorar la disponibilidad y utilización de las unidades.',
          'second': 'Cumplir con el plan de costes anual establecido.',
          'third': 'Mejorar la gestión energética. Consumos y mermas.'
        },
        'title': 'Maximizar la eficiencia de forma sostenible.'
      },
      'third': {
        'objetives': {
          'first': 'Incrementar el compromiso de las personas con el proyecto de Petronor.',
          'second': 'Lanzar la estrategia de digitalización.'
        },
        'title': 'Transformar la cultura y el modelo de gestión.'
      }
    }
  },
  'currentStatus': {
    'events': 'Eventos'
  },
  'menu': {
    'dashboard': 'Dashboard',
    'explorer': 'Explorador',
    'correlation': 'Correlación',
    'logout': 'Cerrar sesión',
    'management': 'Gestión',
    'market': 'Mercado',
    'currentStatus': 'Estado actual',
    'workspace': 'Workspace',
    'process': 'Procesos',
    'queries': 'Consultas',
    'taxonomy': 'Taxonomía',
    'aggregateVariables': 'Variables agregadas',
    'settings': 'Configuración',
    'spanish': 'Español',
    'title': 'Menú',
    'masterLubricationPressure': 'Presión engrase guías Torno 3078',
    'levelsAndRhythms': 'Niveles y ritmos',
    'userManual': 'Ayuda',
    'styleguide': 'Styleguide',
    'csvFoodCompositionIngest': 'Cargador CSV comidas',
    'foodManager': 'Editar alimentos',
    'csvIngest': 'Cargador de CSV',
    'gpxIngest': 'Cargador de GPX',
    'strava': 'Strava',
    'fitbit': 'Fitbit',
    'googleFit': 'Google Fit',
    'oura': 'Oura',
    'withings': 'Withings',
    'garmin': 'Garmin',
    'integrate': 'Panel de Integración',
    'licenseManagement': 'Gestión de licencias',
    'glucoseUploader': 'Cargar Librelink',
    'superSapiens': 'Cargar Supersapiens',
    'glucoseError': 'Error, este archivo no es compatible, cargar un archivo CSV',
    'glucoseGood': 'Los datos de glucosa se han cargado correctamente',
    'glucoseUploaderTittle': 'Subir Datos de Glucosa a',
    'glucoseEntry': 'glucose.entry',
    'glucoseEntryTittle': 'Cargar Datos de Glucosa',
    'glucoseFile': 'Por favor selecciona un archivo CSV',
    'knowMore': 'Saber más'
  },
  'queries': {
    'filterTitle': 'Lectura a',
    'movement': 'Tanques en movimiento',
    'nav': 'Niveles y ritmos',
    'secondaryMenuBtn': 'Menú consultas',
    'title': 'Consulta niveles y ritmos',
    'update': 'Actualizar lectura',
    'createQuery': 'Crear consulta'
  },
  'topbarSettings': {
    'copy': 'Copiar URL',
    'download': 'Descargar',
    'send': 'Enviar por e-mail',
    'print': 'Imprimir',
    'downloadCSV': 'Descargar CSV'
  },
  'rule': {
    'rule': 'Regla',
    'singleRule': 'Regla individual',
    'groupalRule': 'Regla grupal',
    'newRule': 'Nueva regla',
    'addGroupalRule': 'Crear regla grupal',
    'editGroupalRule': 'Editar regla grupal',
    'title': 'Reglas',
    'name': 'Nombre',
    'type': 'Tipo',
    'single': 'Individual',
    'groupal': 'Grupal',
    'creationDate': 'Fecha de creación',
    'createdBy': 'Propietario',
    'enabled': 'Habilitada',
    'successDelete': 'Regla {name} eliminada con éxito',
    'errorDelete': 'Ocurrió un error al eliminar la regla {name}',
    'successCreation': 'Regla {name} creada con éxito',
    'errorCreation': 'Ocurrió un error al crear la regla',
    'successUpdate': 'Regla {name} actualizada con éxito',
    'errorUpdate': 'Ocurrió un error al actualizar la regla',
    'constant': 'Constante',
    'variable': 'Variable',
    'addRule': 'Crear regla',
    'editRule': 'Editar regla',
    'operator': 'Operador',
    'deleteModalTitle': 'Eliminar regla',
    'deleteModalMessage': '¿Estás seguro de que deseas eliminar la regla?',
    'emails': 'Enviar notificaciones por e-mail a estas direcciones (separadas por comas)',
    'emailFieldErrorMessage': 'Introduce direcciones de email válidas',
    'sendAlertsCheckbox': 'Notificar eventos por e-mail',
    'enabledCheckbox': 'Habilitar la regla en la plataforma'
  },
  'commons': {
    'ok': 'OK',
    'yes': 'Sí',
    'no': 'No',
    'accept': 'Aceptar',
    'cancel': 'Cancelar',
    'delete': 'Eliminar',
    'update': 'Editar',
    'save': 'Guardar',
    'confirm': 'Confirmar',
    'mandatoryFieldMessage': 'Campo obligatorio',
    'back': 'Volver',
    'add': 'Añadir',
    'remove': 'Quitar',
    'browserNotSupported': 'Navegador no está soportado',
    'browserSuggestion': 'Descarga <a href="https://www.google.com/chrome/">Google Chrome</a> para disfrutar de todas las funcionalidades.'
  },
  'personalArea': {
    'profile': 'Mi perfil',
    'email': 'Email',
    'rolesAndPermissions': 'Roles y permisos',
    'validateEmail': 'Validar',
    'updatePassword': 'Cambiar contraseña'
  },
  'events': {
    'title': 'Eventos',
    'name': 'Nombre',
    'activationCount': 'Número de activaciones',
    'firstActivation': 'Fecha de la primera activación',
    'lastActivation': 'Fecha de la última activación'
  },
  'query': {
    'title': 'Consultas',
    'name': 'Nombre',
    'path': 'Enlace',
    'owner': 'Propietario',
    'deleteModalMessage': '¿Estás seguro de que deseas eliminar la consulta?',
    'successDelete': 'Consulta {name} eliminada con éxito',
    'errorDelete': 'Ocurrió un error al eliminar la consulta {name}',
    'star': 'Favorita',
    'editQuery': 'Editar consulta',
    'successUpdate': 'Consulta {name} actualizada con éxito',
    'errorUpdate': 'Ocurrió un error al actualizar la consulta',
    'share': 'Permisos'
  },
  'variableManagement': {
    'title': 'Gestión de variables',
    'origin': 'Origen',
    'type': 'Tipo',
    'raw': 'Nativa',
    'aggregate': 'Agregada',
    'categoricalVariables': 'Grupos de variables categóricas',
    'editVariable': 'Editar variable',
    'reference': 'Referencia',
    'quantitative': 'Cuantitativa',
    'categorical': 'Categorica',
    'createCategoricalVariable': 'Crear grupo de variables categóricas',
    'updateCategoricalVariable': 'Editar grupo de variables categóricas',
    'successUpdate': 'Grupo de variables categóricas {name} actualizado con éxito',
    'errorUpdate': 'Ocurrió un error al actualizar el grupo de variables categóricas {name}',
    'assignCategories': 'Asignar categorías',
    'value': 'Valor',
    'groupName': 'Nombre del grupo',
    'addCategory': 'Añadir categoría',
    'name': 'Nombre',
    'owner': 'Propietario',
    'categories': 'Categorías',
    'deleteModalMessage': '¿Seguro que desea eliminar el grupo de variables categóricas?',
    'successDelete': 'Grupo de variables categóricas {name} eliminado con éxito',
    'errorDelete': 'Ocurrió un error al eliminar el grupo de variables categóricas {name}',
    'successCreate': 'Grupo de variables categóricas {name} creado con éxito',
    'errorCreate': 'Ocurrió un error al crear el grupo de variables categóricas {name}',
    'category': 'Categoría',
    'withoutCategory': 'Sin categoría'
  },
  'permission': {
    'titleRule': 'Permisos de la regla',
    'titleAggregateVariable': 'Permisos de la variable agregadada',
    'titleQuery': 'Permisos de la consulta',
    'usersTitle': 'Usuarios',
    'name': 'Nombre',
    'permissions': 'Permisos',
    'groupsTitle': 'Grupos',
    'read': 'Leer',
    'edit': 'Editar',
    'share': 'Compartir',
    'addUserGroup': 'Añadir permiso a usuario o grupo',
    'deleteModalMessage': '¿Estás seguro de que quieres eliminar los permisos asignados al {item}?',
    'errorNoPermissionSelected': 'Selecciona un usuario o grupo',
    'selectorModal': {
      'header': 'Añadir permiso a un usuario o grupo',
      'selectTarget': 'Seleccionar usuario o grupo'
    },
    'overlapTitle': 'Los siguientes usuarios disponían de menos permisos de los asignados a este grupo:',
    'overlapFooter': 'Ahora contarán con los mismos permisos que el grupo.',
    'user': 'usuario',
    'group': 'grupo',
    'successAddPermission': 'Permiso añadido con éxito',
    'errorAddPermission': 'Ocurrió un error al añadir el permiso',
    'successRemovePermission': 'Permiso eliminado con éxito',
    'errorRemovePermission': 'Ocurrió un error al eliminar el permiso'
  },
  'settings': {
    'title': 'Configuración',
    'users': 'Usuarios',
    'groups': 'Grupos y permisos',
    'permission': 'Lectura datos usuarios'
  },
  'group': {
    'title': 'Grupos',
    'name': 'Nombre',
    'add': 'Crear grupo',
    'successUpdate': 'Grupo {name} actualizado con éxito',
    'deleteModalMessage': '¿Estás seguro de que deseas eliminar el grupo?',
    'successDelete': 'Grupo {name} eliminado con éxito',
    'errorDelete': 'Ocurrió un error al eliminar el grupo {name}',
    'new': 'Crear grupo',
    'edit': 'Editar grupo',
    'users': 'Usuarios de {name}',
    'addUser': 'Añadir usuario',
    'successCreation': 'Grupo {name} creado con éxito',
    'errorCreation': 'Ocurrió un error al crear el grupo',
    'errorUpdate': 'Ocurrió un error al actualizar el grupo',
    'removeUser': 'Quita el usuario {name}',
    'groupAlreadyExists': 'El grupo ya existe',
    'addUserModal': {
      'header': 'Usuarios',
      'userNotSelectedError': 'Selecciona un usuario',
      'user': 'Usuario'
    },
    'permissions': {
      'title': 'Permisos de {name}',
      'rulesAndEvents': 'Reglas y eventos',
      'aggregateVariable': 'Variables agregadas',
      'board': 'Board',
      'multiboard': 'Multiboard',
      'summary': 'Resumen',
      'glucose': 'Glucosa',
      'integration': 'Integración',
      'nutritionalPlan': 'Plan nutricional',
      'description': {
        'dashboard': 'El “Dashboard de Gestión” contiene los principales indicadores de la compañía, mostrando su grado de cumplimiento respecto a los objetivos vinculados. Estos indicadores están agrupados bajo las verticales que conforman las diferentes divisiones de la empresa. (Ej. Seguridad, Recursos Humanos, Producción, etc.)',
        'market': 'La pantalla de “Mercado” muestra los principales indicadores de mercado del sector al que pertenece la compañía.',
        'process': 'La funcionalidad de procesos alberga las diferentes pantallas que tienen como objetivo la optimización de los diferentes ratios operativos de la compañía.<br>Estas pantallas contienen soluciones de analítica avanzada adaptadas a los diferentes casos de uso de cada empresa.',
        'explorer': 'El “Explorador” tiene como objetivo la generación de conocimiento a través del análisis de los datos disponibles de la planta. Existen tres tipos de visualizaciones: “Evolución temporal” (gráfico de líneas), “Correlación simple” (scatter plot) y “Correlación múltiple” (4 gráficas simultáneas de scatter plot).',
        'levelsAndRhythms': 'La consulta de “Niveles y Ritmos” muestra el estado del los tanques en tiempo real, con el objetivo de agilizar la toma de decisiones en la operación.',
        'queries': 'El panel de “Consultas” permite acceder directamente a consultas del explorador que han sido previamente guardadas.',
        'taxonomy': 'El panel de “Taxonomía” permite agrupar variables por etiquetas.',
        'rules': 'El módulo de “Eventos” está directamente vinculado al módulo de “Reglas”. En el panel de “Eventos” se muestra el listado de los eventos que han ocurrido como resultado del incumplimiento de una regla definida en la plataforma. La gestión y generación de las reglas se realiza a través del panel “Reglas”.',
        'board': 'El “Board” muestra un resumen de la información general del usuario en un gráfico lineal.',
        'multiboard': 'El “Multiboard” permite mostrar la informacióngeneral de varios usuarios a la vez.',
        'integration': 'Las integraciones permiten a los usuarios obtener información desde fuentes externas.',
        'summary': 'El “Resumen” muestra la información general del usuario, de manera agregada, en distintos tipos de gráficos.',
        'nutritionalPlan': 'El “Plan Nutricional” permite al usuario visualizar los datos de el plan preparado por su nutricionista.',
        'glucose': 'La  “Glucosa” permite al usuario guardar y leer información relacionada con la glucosa.',
        'aggregateVariables': 'El módulo de “Variables agregadas” permite gestionar y generar variables agregadas. Estas variables agregadas están disponibles dentro del explorador.',
        'masterLubricationPressure': 'Contiene la curva de presión del engrase de guías, mostrando cuál es el patrón de la curva y cuál ha sido su evolución en el periodo de tiempo seleccionado.'
      }
    },
    'successUserAdded': 'Usuario añadido con éxito',
    'errorUserAdded': 'Ocurrió un error al añadir un usuario',
    'successUserRemoved': 'Usuario eliminado con éxito',
    'errorUserRemoved': 'Ocurrió un error al eliminar un usuario'
  },
  'user': {
    'title': 'Usuarios',
    'name': 'Nombre',
    'email': 'Email',
    'usernameLabel': 'Nombre de usuario (en minúsculas y sin espacios)',
    'nameLabel': 'Nombre',
    'surnameLabel': 'Apellidos',
    'admin': 'Administrador',
    'xugarkid': 'Xugarkid',
    'nutri': 'Nutri',
    'prescriptor': 'Prescriptor',
    'addFormTitle': 'Crear usuario',
    'successDelete': 'Usuario {name} eliminado con éxito',
    'errorDelete': 'Ocurrió un error al eliminar el usuario {name}',
    'successUpdate': 'Usuario {name} actualizado con éxito',
    'editFormTitle': 'Editar usuario',
    'new': 'Crear usuario',
    'password': 'Contraseña',
    'passwordRepeat': 'Confirmar contraseña',
    'deleteModalMessage': 'Eliminar usuario',
    'passwordShouldBeEqual': 'La contraseña es distinta',
    'successCreation': 'Usuario {name} creado con éxito',
    'errorCreation': 'Ocurrió un error al crear el usuario',
    'errorUpdate': 'Ocurrió un error al actualizar el usuario {name}',
    'passwordFormatMessage': 'La contraseña debe tener como mínimo 6 caracteres y contener letras y números',
    'userAlreadyExists': 'El usuario ya existe',
    'invalidUsername': 'El nombre de usuario no puede contener caracteres especiales',
    'status': 'Estado',
    'enabled': 'habilitado',
    'disabled': 'deshabilitado'
  },
  'masterLubricationPressure': {
    'title': 'Presión engrase guías Torno 3078',
    'from': 'Desde',
    'to': 'hasta',
    'update': 'analizar',
    'patternName': 'Patrón',
    'labelX': 'Puntos de lectura',
    'labelY': 'Bar',
    'tooltipTitle': ' (Valores máximos y mínimos)'
  },
  'userProfile': {
    'title': 'Perfil de usuario',
    'oldPassword': 'Contraseña actual',
    'newPassword': 'Nueva contraseña',
    'newPasswordRepeat': 'Repetir nueva contraseña',
    'passwordWrong': 'Contraseña incorrecta'
  },
  'dashboardDetail': {
    'next': 'siguiente',
    'prev': 'anterior'
  },
  'backoffice': {
    'cacheManagement': 'Gestión caché',
    'cache': {
      'key': 'Clave',
      'value': 'Valor almacenado en caché',
      'time': 'Fecha caché',
      'deleteModalMessage': 'Borrar caché',
      'successDelete': 'Caché borrada correctamente',
      'errorDelete': 'Error borrando caché'
    }
  },
  'permissionAssignment': {
    'title': 'Asignación de permisos',
    'save': {
      'success': 'La lista de usuarios visibles de {name} ha sido actualizada correctamente',
      'errorForUser': 'Ocurrió un error al actualizar los permisos de {name}',
      'error': 'Ocurrió un error al actualizar los permisos'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/es_ES/translations.js